import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://vlmeoanoqgzgvezaujaz.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsbWVvYW5vcWd6Z3ZlemF1amF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA3Mjg4NTUsImV4cCI6MjA4NjMwNDg1NX0.CGLrd3POlRFlECRWmA_BuZTkVbijf7VPOQy8wB2a8AU'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})